


<div class="table-wrapper">
<div class="responsive-table">


<table class="w-full">
  <thead>
    <tr>
      <th>

      </th>
      <th style="min-width: 13.5rem;">
        <div class="td-content">

        </div>
      </th>
      <th class="w-7rem md:w-13rem">
        <div class="td-content ">
          Standard
        </div>
      </th>
      <th class="w-7rem md:w-13rem">
        <div class="td-content">
          Na míru
        </div>
      </th>
    </tr>
  </thead>
  <tbody>

    <ng-container *ngFor="let f of features">
      <ng-container *ngTemplateOutlet="feature, context:{f:f, isParent:true}"></ng-container>
      <ng-container *ngFor="let sf of f.subFeatures ?? []">
        
        <ng-container *ngTemplateOutlet="feature, context:{f:sf, isParent: false}"></ng-container>
      </ng-container>
      <ng-template #feature let-f="f" let-isParent="isParent">
        <tr (click)="f.collapsibleId ? onToggle(f.collapsibleId) : null" [class.cursor-pointer]="isParent && f.collapsibleId" [attr.data-collapsible-id]="f.collapsibleId" [class.collapsible]="!isParent && f.collapsibleId" [class.separate]="isParent">
          <ng-container *ngIf="f.collapsibleId && f.subFeatures?.length; else blankTd">
            <ng-container *ngTemplateOutlet="collap, context:{id:f.collapsibleId}"></ng-container>
          </ng-container>
          <ng-template #blankTd><td></td></ng-template>
    
          <td>
            <div class="td-content">
              <p *ngIf="f.title" class="font-bold">{{f.title}}</p>
              <p *ngIf="f.subtitle">{{f.subtitle}}</p>
              <ng-container *ngIf="f.template">
                <ng-container *ngTemplateOutlet="f.template"></ng-container>
              </ng-container>
            </div>
          </td>
    
          <td>
            <div class="td-content">
              <ng-container *ngTemplateOutlet="featureValue, context:{fv:f.standard}"></ng-container>
            </div>
          </td>
    
          <td>
            <div class="td-content">
              <ng-container *ngTemplateOutlet="featureValue, context:{fv:f.custom}"></ng-container>
            </div>
          </td>
    
          <ng-template #featureValue let-fv="fv">
            <div [style.color]="fv.color ? 'var('+fv.color+')':''">
              <i *ngIf="fv.icon" class="{{ fv.icon }}"></i>
              <span *ngIf="fv.text">{{ fv.text }}</span>
              <ng-container *ngIf="fv.template">
                <ng-container *ngTemplateOutlet="fv.template"></ng-container>
              </ng-container>
              <ng-container *ngIf="fv.progressPercent as prct">
                <div class="circular-progress-wrapper">
                  <svg viewBox="0 0 36 36" class="circular-progress-svg">
                    <circle class="circle-bg"
                            cx="18" cy="18" r="15.91549430918954"
                            fill="none"
                            stroke-width="4">
                    </circle>
                    
                    <circle class="circle-progress"
                            cx="18" cy="18" r="15.91549430918954"
                            fill="none"
                            stroke-width="4"
                            [attr.stroke-dasharray]="2 * Math.PI * progressRadius"
                            [attr.stroke-dashoffset]="(2 * Math.PI * progressRadius) - ((prct / 100) * (2 * Math.PI * progressRadius))"
                            [attr.stroke]="getProgressColor(prct)">
                    </circle>
                    
                    <text x="18" y="23" class="percentage" text-anchor="middle" fill="#333" style="font-size: 0.85em;">{{ prct }}%</text>

                  </svg>
                </div>
              </ng-container>
            </div>
          </ng-template>
        </tr>
      </ng-template>
    </ng-container>

    <!-- templates -->
    <ng-template #qweqweqwe>
      <p class="font-bold">Cenový model</p>
      <p>Hrazeno měsíčně nebo formou ročního předplatného.</p>
    </ng-template>
    <ng-template #qweqweqwe1>
      <p class="font-bold text-green-500">2.5%</p>
      <p>z přijatých plateb</p>
    </ng-template>
    <ng-template #qweqweqwe2>
      <p>Individuální ceny</p>
      <p (click)="onDemo()" class="underline cursor-pointer">kontaktujte nás</p>
    </ng-template>



    <ng-template #opolol>
      <span class="font-bold">Příplatkové položky</span> - možnost nadefinovat extra položky k nákupu jako je výběr z několika jídel, výběr ubytování, výběr doplňků a pod.
    </ng-template>


    <ng-template #nextBestOfferTemplate>
      <p class=""><span class="font-bold">“Next best offer”</span> - doporučení nejlepší další položky k nákupu usnadňující zákazníkovi orientaci v široké nabídce</p>
    </ng-template>


    <tr>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
    </tr>

  </tbody>
</table>

</div>
</div>




<ng-template #collap let-id="id">
  <td  class="table-col-min-width cursor-pointer pl-4 pr-2">
    <i *ngIf="!uncollapsedIds.includes(id)" class="pi pi-chevron-down"></i>
    <i *ngIf="uncollapsedIds.includes(id)" class="pi pi-chevron-up"></i>
  </td>
</ng-template>